import React, { useState, useEffect } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useScoring, isRedZone } from '../lib/scoring';
import {
  LargeTitle, Section, ListGroup, ListRow, Monogram, ScorePill, SearchField, ScoreHero, PageSkeleton, EmptyRow,
} from '../components/ui';

function greeting() {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 18) return 'Good afternoon';
  return 'Good evening';
}

export default function Dashboard() {
  const { profile } = useAuth();
  const { threshold, weights } = useScoring();
  const [search, setSearch] = useState('');
  const [clinics, setClinics] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!profile?.id) return;
    Promise.all([api.dashboard.chart(), api.clinics.list()])
      .then(([chart, clinicsList]) => {
        setChartData(chart);
        setClinics(clinicsList);
        clinicsList.slice(0, 10).forEach((c) => api.prefetchClinic(c.id));
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [profile?.id]);

  if (loading) return <PageSkeleton />;

  const shown = clinics.filter((c) => c.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <LargeTitle eyebrow={`${greeting()}${profile?.first_name ? `, ${profile.first_name}` : ''}`} title="Dashboard" />
      <ScoreHero label="Average CScore, all clinics" data={chartData} />
      <Section title="Clinics" detail={`${clinics.length} total`}>
        {clinics.length > 6 && <SearchField value={search} onChange={setSearch} placeholder="Search clinics" />}
        <ListGroup>
          {shown.length === 0 && <EmptyRow>No clinics found</EmptyRow>}
          {shown.map((clinic) => (
            <ListRow
              key={clinic.id}
              to={`/clinics/${clinic.id}`}
              leading={<Monogram name={clinic.name} score={clinic.avg_cscore} src={clinic.image_url} />}
              title={clinic.name}
              subtitle={`${clinic.clinician_count} clinician${clinic.clinician_count !== 1 ? 's' : ''}`}
              trailing={(
                <ScorePill
                  score={clinic.avg_cscore}
                  flagged={isRedZone(clinic.avg_cscore, threshold)}
                  breakdown={clinic.breakdown}
                  weights={weights}
                  title={`${clinic.name} average`}
                />
              )}
            />
          ))}
        </ListGroup>
      </Section>
    </div>
  );
}
